<template>
    <div>
        <div class="d-flex flex-column flex-md-row flex-wrap">
            <b-col cols="12">
                <b-tabs
                    content-class="position-relative"
                    nav-class="nav-tabs flex-nowrap overflow-auto"
                >
                    <div class="w-100 border-bottom"></div>
                    <b-tab active>
                        <template #title>
                            <span>{{ form?.request_type_name }}</span>
                        </template>
                        <b-row>
                            <b-col cols="12">
                                <b-card v-if="form?.id">
                                    <component v-if="type" :is="type" :data="form"
                                               :is-read-only="true"></component>
                                </b-card>
                            </b-col>
                        </b-row>
                    </b-tab>

                    <b-tab>
                        <template #title>
                            <span>{{ $t('resident_information') }}</span>
                        </template>
                        <b-row>
                            <b-col cols="12" class="p-3">
                                <b-card class="h-100">
                                    <b-row>
                                        <b-col cols="12" sm="6" class="mb-3">
                                            <b-form-group :label="$t('name')">
                                                <b-input-group>
                                                    <div class="form-control bg-light border rounded p-2 text-break">
                                                        {{ form.name || '-' }}
                                                    </div>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="12" sm="6" class="mb-3">
                                            <b-form-group :label="$t('email')">
                                                <b-input-group>
                                                    <div class="form-control bg-light border rounded p-2 text-break">
                                                        {{ form.email || '-' }}
                                                    </div>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="12" sm="6" class="mb-3">
                                            <b-form-group :label="$t('phone_number')">
                                                <b-input-group>
                                                    <div class="form-control bg-light border rounded p-2 text-break">
                                                        {{ form.mobile_tel || '-' }}
                                                    </div>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="12" sm="6" class="mb-3">
                                            <b-form-group :label="$t('country_code')">
                                                <b-input-group>
                                                    <div class="form-control bg-light border rounded p-2 text-break">
                                                        {{ form.country_code || '-' }}
                                                    </div>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                </b-card>
                            </b-col>
                        </b-row>
                    </b-tab>

                    <b-tab>
                        <template #title>
                            <span>{{ $t('reservation_information') }}</span>
                        </template>
                        <b-row>
                            <b-col cols="12" class="p-3">
                                <b-card>
                                    <b-row>
                                        <b-col cols="12" sm="6" class="mb-3">
                                            <b-form-group :label="$t('building')">
                                                <b-input-group>
                                                    <div class="form-control bg-light border rounded p-2 text-break">
                                                        {{ form.building_name || '-' }}
                                                    </div>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="12" sm="6" class="mb-3">
                                            <b-form-group :label="$t('room')">
                                                <b-input-group>
                                                    <div class="form-control bg-light border rounded p-2 text-break">
                                                        {{ form.room_name || '-' }}
                                                    </div>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="12" sm="6" class="mb-3">
                                            <b-form-group :label="$t('room_type')">
                                                <b-input-group>
                                                    <div class="form-control bg-light border rounded p-2 text-break">
                                                        {{ form.room_type_name || '-' }}
                                                    </div>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="12" sm="6" class="mb-3">
                                            <b-form-group :label="$t('bed')">
                                                <b-input-group>
                                                    <div class="form-control bg-light border rounded p-2 text-break">
                                                        {{ form.bed_name || '-' }}
                                                    </div>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="12" sm="6" class="mb-3">
                                            <b-form-group :label="$t('bed_type')">
                                                <b-input-group>
                                                    <div class="form-control bg-light border rounded p-2 text-break">
                                                        {{ form.bed_type_name || '-' }}
                                                    </div>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="12" sm="6" class="mb-3">
                                            <b-form-group :label="$t('bed_type')">
                                                <b-input-group>
                                                    <div class="form-control bg-light border rounded p-2 text-break">
                                                        {{ form.bed_type_name || '-' }}
                                                    </div>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="12" sm="6" class="mb-3">
                                            <b-form-group :label="$t('check_in_date')">
                                                <b-input-group>
                                                    <div class="form-control bg-light border rounded p-2 text-break">
                                                        {{ form.check_in_date || '-' }}
                                                    </div>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="12" sm="6" class="mb-3">
                                            <b-form-group :label="$t('check_out_date')">
                                                <b-input-group>
                                                    <div class="form-control bg-light border rounded p-2 text-break">
                                                        {{ form.check_out_date || '-' }}
                                                    </div>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                </b-card>
                            </b-col>
                        </b-row>
                    </b-tab>

                    <b-tab>
                        <template #title>
                            <span>{{ $t('files') }}</span>
                        </template>
                        <b-row>
                            <b-col cols="12" class="p-3 mt-3">
                                <b-card class="h-100">
                                    <b-row>
                                        <b-col cols="12" class="mb-3">
                                            <b-form-group :label="$t('request_files')">
                                                <template v-if="form.files.length">
                                                    <div v-for="file in form.files" :key="file.uuid">
                                                        <b-input-group class="mb-2">
                                                            <div
                                                                class="form-control bg-light border rounded p-2 text-break">
                                                                {{ file.file_name }}
                                                            </div>
                                                            <b-input-group-append>
                                                                <b-button
                                                                    variant="primary"
                                                                    @click="downloadFile(file.uuid, file.file_name)"
                                                                    v-b-tooltip.hover
                                                                    title="Download Document"
                                                                    :disabled="!file.uuid"
                                                                >
                                                                    <i class="ri-arrow-down-line"></i>
                                                                </b-button>
                                                            </b-input-group-append>
                                                        </b-input-group>
                                                    </div>
                                                </template>
                                                <template v-else>
                                                    <b-input-group class="mb-2">
                                                        <div
                                                            class="form-control bg-light border rounded p-2 text-break">
                                                            {{ $t('file_not_found') }}
                                                        </div>
                                                    </b-input-group>
                                                </template>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="12" class="mb-3">
                                            <b-form-group
                                                :label="$t('other_files')"
                                                v-if="form.agreement_files.length || form.work_order_completed_files.length"
                                            >
                                                <template v-if="form.agreement_files.length">
                                                    <div v-for="file in form.agreement_files" :key="file.uuid">
                                                        <b-input-group class="mb-2">
                                                            <div
                                                                class="form-control bg-light border rounded p-2 text-break">
                                                                {{ file.file_name }}
                                                            </div>
                                                            <b-input-group-append>
                                                                <b-button
                                                                    variant="primary"
                                                                    @click="downloadFile(file.uuid, file.file_name)"
                                                                    v-b-tooltip.hover
                                                                    title="Download Document"
                                                                    :disabled="!file.uuid"
                                                                >
                                                                    <i class="ri-arrow-down-line"></i>
                                                                </b-button>
                                                            </b-input-group-append>
                                                        </b-input-group>
                                                    </div>
                                                </template>
                                                <template v-if="form.work_order_completed_files.length">
                                                    <div v-for="file in form.work_order_completed_files"
                                                         :key="file.uuid">
                                                        <b-input-group class="mb-2">
                                                            <div
                                                                class="form-control bg-light border rounded p-2 text-break">
                                                                {{ file.file_name }}
                                                            </div>
                                                            <b-input-group-append>
                                                                <b-button
                                                                    variant="primary"
                                                                    @click="downloadFile(file.uuid, file.file_name)"
                                                                    v-b-tooltip.hover
                                                                    title="Download Document"
                                                                    :disabled="!file.uuid"
                                                                >
                                                                    <i class="ri-arrow-down-line"></i>
                                                                </b-button>
                                                            </b-input-group-append>
                                                        </b-input-group>
                                                    </div>
                                                </template>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                </b-card>
                            </b-col>
                        </b-row>
                    </b-tab>
                </b-tabs>
            </b-col>


            <!-- Message to Student -->
                <b-col cols="12" class="p-3 mt-3" v-if="form.request_type === 'work_order_request'">
                    <b-card class="h-100">
                        <b-row>
                            <ValidationObserver ref="formModalValidate">
                                <b-col cols="12" class="mb-3">
                                    <label>{{ $t('Message to Student') }}</label>
                                    <ValidationProvider name="message_to_student" rules="" v-slot="{ valid, errors }">
                                        <b-form-textarea
                                            v-model="form.message_to_student"
                                            :class="{ 'is-invalid': errors[0] }"
                                            rows="5"
                                        />
                                        <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"/>
                                    </ValidationProvider>
                                </b-col>
                            </ValidationObserver>
                        </b-row>
                    </b-card>
                </b-col>

                <!-- Security Deposit Refund Request -->
                <b-col cols="12" class="p-3 mt-3" v-if="form.request_type === 'security_deposit_refund_request'">
                    <b-card class="h-100">
                        <ValidationObserver ref="formModalValidate">
                            <b-row>
                                      <b-col cols="12" md="4" class="mb-3">
                                    <label>{{ $t('amount_paid') }}</label>
                                    <ValidationProvider
                                        name="amount_paid"
                                        rules="required"
                                        v-slot="{ valid, errors }"
                                    >
                                        <b-form-input
                                            type="number"
                                            v-model="requestData.amount_paid"
                                            :state="errors[0] ? false : null"
                                        />
                                        <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"/>

                                    </ValidationProvider>
                                </b-col>
                                      <b-col cols="12" md="4" class="mb-3">
                                      <label>{{ $t('non_refund_amount') }}</label>
                                      <ValidationProvider
                                        name="non_refundable_amount"
                                        rules="required"
                                        v-slot="{ valid, errors }"
                                    >
                                        <b-form-input
                                            type="number"
                                            v-model="requestData.non_refundable_amount"
                                            :state="errors[0] ? false : null"
                                        />
                                        <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"/>

                                    </ValidationProvider>
                                    </b-col>
                                      <b-col cols="12" md="4" class="mb-3">
                                    <label>{{ $t('refund_amount') }}</label>
                                    <ValidationProvider
                                        name="refund_amount"
                                        rules="required"
                                        v-slot="{ valid, errors }"
                                    >
                                        <b-form-input
                                            type="number"
                                            v-model="requestData.refund_amount"
                                            :state="errors[0] ? false : null"
                                        />
                                        <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"/>

                                    </ValidationProvider>
                                </b-col>
                            </b-row>
                        </ValidationObserver>
                    </b-card>
                </b-col>

                <!-- Request Information -->
                <b-col cols="12" class="p-3 mt-3">
                    <b-card :title="$t('request_information')" class="h-100">
                        <ValidationObserver ref="formModalValidate">
                            <b-row>
                                    <b-col cols="12" sm="6" class="mb-3">
                                        <label>{{ $t('request_type') }}</label>
                                        <b-input-group>
                                            <div class="form-control bg-light border rounded p-2 text-break">
                                                {{ form.request_type_name || '-' }}
                                            </div>
                                        </b-input-group>
                                    </b-col>
                                    <b-col cols="12" sm="6" class="mb-3" v-if="form.request_type === 'security_deposit_refund_request'">
                                        <ValidationProvider name="explanation" :rules="['waiting','declined'].includes(form.status)?'required':''" v-slot="{ valid, errors }">
                                            <label>{{ $t('explanation') }}</label>
                                            <parameter-selectbox
                                                v-model="form.explanation"
                                                code="housing_security_deposit_refund_explanations"
                                                :validate-error="errors[0]"
                                                :state="errors[0] ? false : null"
                                            />
                                      </ValidationProvider>
                                    </b-col>
                                    <b-col cols="12" sm="6" class="mb-3">
                                            <ValidationProvider name="status" rules="required" v-slot="{ errors }">
                                                <label><b>{{ $t('status') }}</b></label>
                                                <parameter-selectbox
                                                    v-show="form.request_type === 'work_order_request'"
                                                    v-model="form.status"
                                                    code="housing_work_order_request_statuses"
                                                />
                                                <parameter-selectbox
                                                    v-show="form.request_type !== 'work_order_request'"
                                                    v-model="form.status"
                                                    code="housing_request_statuses"
                                                />
                                            </ValidationProvider>
                                    </b-col>
                            </b-row>
                        </ValidationObserver>
                    </b-card>
                </b-col>
        </div>

        <!-- Save Button -->
        <div class="d-flex justify-content-center mt-3" v-if="checkPermission('housingrequest_changestatus')">
            <b-button variant="primary" @click="updateStatus">
                {{ $t('save') }}
            </b-button>
        </div>
    </div>
</template>

<script>
import HousingRequestListServices from "@/services/HousingRequestListServices";
import bedHoldRequest from '@/modules/myReservationList/pages/student/bedHoldRequest/Index'
import serviceAnimal from '@/modules/myReservationList/pages/student/serviceAnimal/Index'
import fobReplacement from '@/modules/myReservationList/pages/student/fobReplacement/Index'
import roomKeyReplacement from '@/modules/myReservationList/pages/student/roomKeyReplacement/Index'
import roomChangeRequest from '@/modules/myReservationList/pages/student/roomChangeRequest'
import workOrderRequest from '@/modules/myReservationList/pages/student/workOrderRequest/Index'
import initialComplaint from '@/modules/myReservationList/pages/student/initialComplaint/Index'
import religiousExemption from '@/modules/myReservationList/pages/student/religiousExemption/Index'
import airportTransferRequest from "@/modules/myReservationList/pages/student/airportTransferRequest/Index.vue"
import securityDepositRefundRequest from "@/modules/myReservationList/pages/student/securityDepositRefundRequest/Index.vue";

export default {
    components: {
        securityDepositRefundRequest,
        bedHoldRequest,
        serviceAnimal,
        fobReplacement,
        roomKeyReplacement,
        roomChangeRequest,
        workOrderRequest,
        initialComplaint,
        religiousExemption,
        airportTransferRequest,
    },
    props: {
        formId: {}
    },
    data() {
        return {
            form: {
                id: null,
                name: null,
                email: null,
                mobile_tel: null,
                country_code: null,
                building_name: null,
                room_name: null,
                room_type_name: null,
                bed_name: null,
                bed_type_name: null,
                request_type: null,
                request_type_name: null,
                explanation: null,
                status: null,
                agreement_files: [],
                files: [],
                request_data: [],
                work_order_completed_files: []
            }
        };
    },
    computed: {
        requestData() {
            return this.form.request_data
        },
        type() {
            if (this.form.request_type) {
                return this.form.request_type?.replaceAll('_', '-')
            }
            return null
        }
    },
    created() {
        this.getData();
    },
    methods: {
        async getData() {
            HousingRequestListServices.showAdmin(this.formId)
                .then((res) => {
                    const data = res.data.data;
                    let request_data = data.request_data;
                    this.form = {
                        id: data.id,
                        request_data: request_data,
                        name: `${data.name} ${data.surname}`,
                        email: data.email || '-',
                        mobile_tel: data.mobile_tel || '-',
                        country_code: data.mobile_tel_country_code || '-',
                        building_name: data.building_name || '-',
                        room_name: data.room_name || '-',
                        room_type_name: data.room_type_name || '-',
                        message_to_student: request_data?.message_to_student || '',
                        bed_name: data.bed_name || '-',
                        bed_type_name: data.bed_type_name || '-',
                        request_type: data.request_type || '-',
                        request_type_name: data.request_type_name || '-',
                        explanation: data.explanation,
                        files: data.files || [],
                        status: data.status,
                        check_in_date: data.check_in_date || '-',
                        check_out_date: data.check_out_date || '-',
                        flight_code: data.request_data?.flight_code || '-',
                        agreement_files: data.agreement_files ?? [],
                        work_order_completed_files: data.work_order_completed_files ?? [],
                    };
                })
                .catch((error) => {
                    this.showErrors(error);
                });
        },
        async updateStatus() {
            const isValid = await this.$refs.formModalValidate.validate();
            if (isValid) {
                if (this.form.request_type === 'security_deposit_refund_request') {
                    this.form.amount_paid = this.requestData.amount_paid
                    this.form.non_refundable_amount = this.requestData.non_refundable_amount
                    this.form.refund_amount = this.requestData.refund_amount

                }
                try {
                    const res = await HousingRequestListServices.changeStatusRequest(this.formId, this.form);
                    this.$toast.success(this.$t("api." + res.data.message));
                    this.$emit("successStatusUpdate", true);
                } catch (error) {
                    this.showErrors(error,this.$refs.formModalValidate)
                }
            }
        },
        downloadFile(uuid, filename) {
            HousingRequestListServices.downloadFile(uuid)
                .then((response) => {
                    this._downloadFile(response, filename)
                })
                .catch((err) => {
                    this.showErrors(err);
                });
        }
    }
};
</script>
